import { ResponseError } from '../errors';
import { IOfferSchema } from '../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';
import { IPageSchema } from '../repositories/chats/entities/get_my_offers_for_selection/PageSchema';
import {
  fetchGetMyOffersForSelectionDesktop,
  IGetMyOffersForSelectionDesktopRequest,
  TGetMyOffersForSelectionDesktopResponse,
} from '../repositories/chats/v1/get-my-offers-for-selection-desktop';
import { TContext } from '../types/context';

type TFetchSelectorOffersParams = {
  parameters: IGetMyOffersForSelectionDesktopRequest;
  cookies?: string;
};

interface IResponse {
  offers: IOfferSchema[];
  page?: IPageSchema;
  statusCode?: number;
}

export const fetchOffersForSelection = async (
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchSelectorOffersParams,
): Promise<IResponse> => {
  try {
    const { response, statusCode }: TGetMyOffersForSelectionDesktopResponse = await fetchGetMyOffersForSelectionDesktop(
      {
        httpApi,
        parameters,
        config: {
          requestConfig: {
            headers: cookies ? [['Cookie', cookies]] : [],
            withCredentials: true,
          },
        },
      },
    );

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchOffersForSelection',
        message: 'Failed to fetch offers for selection',
      });
    }

    return {
      offers: response.offers,
      page: response.page,
      statusCode,
    };
  } catch (error) {
    logger.warning(error, {
      domain: 'src/shared/services/fetchSelectorOffers.ts [fetchSelectorOffers]',
      message: 'Не удалось получить список объявлений для селектора',
    });

    return { offers: [] };
  }
};
